
const LastPoint = (props) => {  
    
    const positions = props.track?.positions  
    if(positions){
        const pos = positions[positions.length -1]
        if(pos){
            return pos.latitude + " " + pos.longitude
        }
    }
    return "";
}

export default LastPoint;